import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class BackgroundFileService {
  constructor() {}

  filesUploading = new BehaviorSubject(false);

  addFilesUploading(): void {
    this.filesUploading.next(true);
  }

  removeFilesUploading(): void {
    this.filesUploading.next(false);
  }
}
